import type { AnyFn } from "@vueuse/core";
import { handleInitError } from "./error";
import { fetchEnvVariables, setEnvVariables } from "./utils";
import { maybeBackupReferralQueryParams } from "@/utils/referrals";

export async function bootstrapAppWithEnvVariables(cb: AnyFn) {
  try {
    useAppInit().startInitializing();
    // get referral data
    maybeBackupReferralQueryParams();
    // comment out to use remote env locally
    if (import.meta.env.DEV) {
      for (const key in import.meta.env) {
        env[key] = `${import.meta.env[key]}`;
      }
      cb();
      return;
    }
    const data = await fetchEnvVariables();
    setEnvVariables(data);
    cb();
  } catch (e) {
    handleInitError();
    console.error(e);
  }
}
